import { Controller } from '@hotwired/stimulus'
import { jquery } from 'utils/jquery'

export default class extends Controller {
  static targets = ['languageSelect']

  initialize() {
    const $ = jquery()

    if ($) {
      const languageSelect = $(this.languageSelectTarget).select2()

      // Redirect to the same URL with the selected locale as a query param
      languageSelect.on('change', () => {
        this.redirectToLocale(languageSelect.val())
      })
    } else {
      // select2 fires only jQuery events — without jQuery, fall back to a plain
      // native listener so voters can still switch language (Rollbar #3267).
      this.languageSelectTarget.addEventListener('change', () => {
        this.redirectToLocale(this.languageSelectTarget.value)
      })
    }
  }

  redirectToLocale(selectedLocale) {
    try {
      const url = new URL(window.location.href)
      url.searchParams.set('locale', selectedLocale)
      window.location.href = url.href
    } catch (e) {
      // Fallback for older browsers
      console.warn('Failed to update locale in URL, using fallback.', e)
      window.location.href = window.location.pathname + '?locale=' + encodeURIComponent(selectedLocale)
    }
  }
}
